import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isInstanceOf } from './is.js';
import { truncate } from './string.js';
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */

function applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser) {
  var maxValueLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 250;
  var key = arguments.length > 3 ? arguments[3] : undefined;
  var limit = arguments.length > 4 ? arguments[4] : undefined;
  var event = arguments.length > 5 ? arguments[5] : undefined;
  var hint = arguments.length > 6 ? arguments[6] : undefined;

  if (!event.exception || !event.exception.values || !hint || !isInstanceOf(hint.originalException, Error)) {
    return;
  } // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error


  var originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined; // We only create exception grouping if there is an exception in the event.

  if (originalException) {
    event.exception.values = truncateAggregateExceptions(aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
  }
}

function aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
  if (prevExceptions.length >= limit + 1) {
    return prevExceptions;
  }

  var newExceptions = _toConsumableArray(prevExceptions); // Recursively call this function in order to walk down a chain of errors


  if (isInstanceOf(error[key], Error)) {
    applyExceptionGroupFieldsForParentException(exception, exceptionId);
    var newException = exceptionFromErrorImplementation(parser, error[key]);
    var newExceptionId = newExceptions.length;
    applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
    newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [newException].concat(_toConsumableArray(newExceptions)), newException, newExceptionId);
  } // This will create exception grouping for AggregateErrors
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError


  if (Array.isArray(error.errors)) {
    error.errors.forEach(function (childError, i) {
      if (isInstanceOf(childError, Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);

        var _newException = exceptionFromErrorImplementation(parser, childError);

        var _newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(_newException, "errors[".concat(i, "]"), _newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [_newException].concat(_toConsumableArray(newExceptions)), _newException, _newExceptionId);
      }
    });
  }

  return newExceptions;
}

function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || {
    type: 'generic',
    handled: true
  };
  exception.mechanism = _objectSpread(_objectSpread(_objectSpread({}, exception.mechanism), exception.type === 'AggregateError' && {
    is_exception_group: true
  }), {}, {
    exception_id: exceptionId
  });
}

function applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || {
    type: 'generic',
    handled: true
  };
  exception.mechanism = _objectSpread(_objectSpread({}, exception.mechanism), {}, {
    type: 'chained',
    source: source,
    exception_id: exceptionId,
    parent_id: parentId
  });
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */


function truncateAggregateExceptions(exceptions, maxValueLength) {
  return exceptions.map(function (exception) {
    if (exception.value) {
      exception.value = truncate(exception.value, maxValueLength);
    }

    return exception;
  });
}

export { applyAggregateErrorsToEvent };